'use strict';

(function () {
  'use strict';

  angular.module('msTracker').component('msTrackerChart', {
    bindings: {
      trackerId: '<',
      trackerTitle: '<',
      ceilingLabel: '<',
      floorLabel: '<',
      color: '<',
      timeSegment: '<',
      initDate: '<'
    },
    templateUrl: 'tracker/templates/chart.html',
    controller: TrackerChartsController
  });

  TrackerChartsController.$inject = ['moodTrackerSvc', '$log', '$timeout', '$q', 'userSvc', 'NotifyingSvc'];

  // Animation Duration + Animation Delay * (bars on chart + Base Delay) + Padding for safety.
  // Weekly and Yearly views are slightly shorter, but for simplicity's sake,
  // we will use the Monthly animation time for future calculations.
  var monthChartTransitionTime = 250 + 50 * (31 + .5) + 200;
  var chartTransitionTime = 300;
  var timeSegments = {
    'week': {
      displayName: 'vnext.tools.tracker.chartRangeLabels.week',
      getData: _.noop,
      hasBeenSeen: false
    },
    'month': {
      displayName: 'vnext.tools.tracker.chartRangeLabels.month',
      getData: _.noop,
      hasBeenSeen: false
    },
    'year': {
      displayName: 'vnext.tools.tracker.chartRangeLabels.year',
      getData: _.noop,
      hasBeenSeen: false
    }
  };

  function TrackerChartsController(moodTrackerSvc, $log, $timeout, $q, userSvc, NotifyingSvc) {
    var vm = this;
    vm.$onInit = init;
    vm.title = 'msTrackerChart: ' + vm.trackerId;
    vm.page = 0;
    vm.selectedTimeSegment = {};
    var timeSegmentTimeout = void 0,
        chartFadeTimeout = void 0,
        fadeAnimationTimeout = void 0,
        dataRequestAndTransitionFade = void 0;
    vm.$onDestroy = function () {
      return destroyAllTimers([timeSegmentTimeout, chartFadeTimeout, fadeAnimationTimeout], $timeout);
    };
    vm.openChartDetailOverlayModal = function (startDate, endDate, trackerId) {
      return openChartDetailOverlayModal(startDate, endDate, trackerId, NotifyingSvc);
    };

    function changeTimeSegment(segment, newPage) {
      if (segment === vm.timeSegment) {
        return;
      }
      vm.page = newPage || 0;
      // This object will save state of the aria-pressed for 'timeSegment' buttons(special case in safari macOS)
      vm.selectedTimeSegment[segment] = true;
      vm.selectedTimeSegment[vm.timeSegment] = false;
      // Delay this change until after the chart fades away.
      // This prevents the labels from changing font-size before the new chart is visible.
      timeSegmentTimeout = $timeout(function () {
        return vm.timeSegment = segment;
      }, chartTransitionTime);
      updateChart(segment);
    }

    function updateChart(segment) {
      vm.loadingData = true;
      $timeout.cancel(chartFadeTimeout);
      chartFadeTimeout = $timeout(function () {
        return true;
      }, chartTransitionTime);
      // We need to wait for BOTH the current data on the chart to fade out
      // and for the data request to come back before fading the new chart/titles in.
      dataRequestAndTransitionFade = [getChartData(vm.trackerId, segment, vm.page), chartFadeTimeout];
      $q.all(dataRequestAndTransitionFade).then(function (data) {
        data = data[0];
        vm.chartData = data;
        vm.loadingData = false;
        // We need to wait until the new chart has fully transitioned in before
        // setting it as "seen". If hasBeenSeen is set to true too early,
        // the animation style will change mid-transtion, resulting in jank.
        chartFadeTimeout = $timeout(function () {
          return timeSegments[segment].hasBeenSeen = true;
        }, monthChartTransitionTime);
      });
    }

    function retreatDateRange() {
      $timeout.cancel(fadeAnimationTimeout);
      vm.page++;
      vm.transitionRight = true;
      updateChart(vm.timeSegment);
      fadeAnimationTimeout = $timeout(function () {
        return vm.transitionRight = false;
      }, chartTransitionTime);
    }

    function advanceDateRange() {
      $timeout.cancel(fadeAnimationTimeout);
      vm.page--;
      vm.transitionLeft = true;
      updateChart(vm.timeSegment);
      fadeAnimationTimeout = $timeout(function () {
        return vm.transitionLeft = false;
      }, chartTransitionTime);
    }

    function isEndOfData(page) {
      return vm.timeSegment ? pageToPageEndDate(page + 1, vm.timeSegment).isBefore(vm.userSignupDate) : true;
    }

    vm.segmentHasBeenSeen = function (segment) {
      return segment ? vm.timeSegments[segment].hasBeenSeen : true;
    };

    ////////////////

    function init() {
      $log.debug(vm.title + ' activate');
      vm.chartColorClass = 'chart-color-' + vm.color;
      vm.startDate = moment(vm.initDate) || moment();
      vm.title = 'msTrackerChart';
      vm.changeTimeSegment = changeTimeSegment;
      vm.retreatDateRange = retreatDateRange;
      vm.advanceDateRange = advanceDateRange;
      vm.isEndOfData = isEndOfData;

      timeSegments['week'].getData = moodTrackerSvc.getWeeklyData;
      timeSegments['month'].getData = moodTrackerSvc.getMonthlyData;
      timeSegments['year'].getData = moodTrackerSvc.getYearlyData;
      vm.timeSegments = timeSegments;

      userSvc.getUser().then(function (user) {
        vm.userSignupDate = moment(user.createdOn);
        vm.timeSegment = vm.timeSegment || (moment().diff(vm.userSignupDate, 'days') > 15 ? 'month' : 'week');
        updateChart(vm.timeSegment);
        NotifyingSvc.subscribe(NotifyingSvc.EVENTS.REFRESH_TRACKER, function () {
          return updateChart(vm.timeSegment);
        });
      });
    }
  }

  function getChartData(trackerId, timeSegment, page) {
    return timeSegments[timeSegment].getData(trackerId, moment.tz.guess(), page);
  }

  function pageToPageEndDate(page, segment) {
    switch (segment) {
      case 'week':
        return moment().subtract(page * 7, 'days');
      case 'month':
        return moment().subtract(page * 31, 'days');
      case 'year':
        return moment().subtract(page * 12, 'months');
      default:
        return;
    }
  }

  function openChartDetailOverlayModal(startDate, endDate, trackerId, NotifyingSvc) {
    NotifyingSvc.notifyEvent(NotifyingSvc.EVENTS.OPEN_MODAL, {
      templateUrl: 'tracker/templates/chart-overlay-detail.html',
      controller: 'chartDetailOverlayCtrl',
      inputs: {
        start: startDate,
        end: endDate,
        trackerId: trackerId
      }
    });
  }

  function destroyAllTimers(arrayOfTimers, $timeout) {
    arrayOfTimers.forEach(function (timer) {
      return $timeout.cancel(timer);
    });
  }
})();